import { render, staticRenderFns } from "./DisputedStudentList.vue?vue&type=template&id=39970436&"
import script from "./DisputedStudentList.vue?vue&type=script&lang=js&"
export * from "./DisputedStudentList.vue?vue&type=script&lang=js&"
import style0 from "./DisputedStudentList.vue?vue&type=style&index=0&id=39970436&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports